import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import {
  SupportTickets,
  resetFilters,
  setFilters,
  setFiltersDialog,
} from "../../app/slices/supportTicketsSlice";

const STATUS_OPTIONS = [
  { label: "New", value: "new" },
  { label: "In Progress", value: "in_progress" },
  { label: "Resolved", value: "resolved" },
];

export default function Filter({ fetchData }) {
  const {
    tickets: { filters, dialog },
  } = useSelector((state) => state.supportTickets);
  const dispatch = useDispatch();

  const handleSearch = () => {
    fetchData();
    dispatch(setFiltersDialog());
  };

  const handleRemoveSearch = () => {
    dispatch(resetFilters());
    dispatch(SupportTickets.index());
    dispatch(setFiltersDialog());
  };

  const list = (
    <Box sx={{ width: 350, mt: 8 }} role="presentation">
      <Grid container rowSpacing={1} sx={{ px: 1, pt: 2 }}>
        <Grid item xs={12}>
          <Typography variant="h6">Filter Tickets</Typography>
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            options={STATUS_OPTIONS}
            value={filters.status}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            onChange={(e, newValue) => {
              dispatch(setFilters({ status: newValue }));
            }}
            renderInput={(params) => (
              <TextField {...params} label="Status" size="small" fullWidth />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            onClick={handleSearch}
            sx={{ width: "100%" }}
            variant="outlined"
            startIcon={<SearchIcon />}
          >
            Search
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Button
            onClick={handleRemoveSearch}
            color="error"
            sx={{ width: "100%", mt: 1 }}
            variant="outlined"
            startIcon={<DeleteIcon />}
          >
            Remove
          </Button>
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <React.Fragment>
      <Drawer
        anchor="right"
        open={dialog}
        onClose={() => dispatch(setFiltersDialog())}
      >
        {list}
      </Drawer>
    </React.Fragment>
  );
}
